import BaseRepository from '@/baseRepository/BaseRepository';
const resource = `/api/v1/users`;
 
export default {
  getProfilePicture(baseURL, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/profile-picture`, {
      baseURL,
      headers,
      params,
    });
  },
  getUserDetail(baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`${resource}/detail`, {
      baseURL,
      headers,
      params,
    });
  },

  postProfilePicture(body, baseURL, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}/profile-picture`, body, {
      baseURL,
      headers,
      params,
    });
  },
  getUserInfo( baseURL, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/byphone`, {
      baseURL,
      headers,
      params,
    });
  },
    getUserByPhone(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/byphone`, {
      baseURL,
      headers,
      params
    });
  }
};
